import {
  Dispatch,
  SetStateAction,
  useContext,
  useEffect,
  useState
} from "react";
import AppContext from "../../../services/app-context-services";
import FetchData from "../../shared/fetch-data/fetch-data";
import { API } from "../../../services/api-services";
import AppPullMessagePopup from "../pull-message-popup/PullMessagePopup";
import { PullMessageResponse } from "../models";
import { makeHash } from "./helper";

interface PullMessageComponentProps {
  action_type: number;
  setIsLoading?: Dispatch<SetStateAction<boolean>>;
  onMessage?: (message: PullMessageResponse) => void;
}

const secret_key = process.env.SECRET_KEY_PULL_MESSAGE || "waydownwego";
const service_uuid =
  process.env.SERVICE_UUID_PULL_MESSAGE ||
  "0c00b822-9175-4464-ad22-f1d461212004";

export default function PullMessageComponent({
  action_type,
  onMessage,
  setIsLoading
}: PullMessageComponentProps) {
  const [message, setMessage] = useState<PullMessageResponse>();
  const [token, setToken] = useState(""); // not to be confused with auth token
  const [counter, setCounter] = useState(0);
  const [isShowPullMessage, setIsShowPullMessage] = useState(false);
  const { dg_id } = useContext(AppContext);

  useEffect(() => {
    if (!dg_id) return;

    makeHash(dg_id, secret_key)
      .then(hash => {
        setToken(hash);
      })
      .catch(e => console.log(e));
  }, [dg_id]);

  useEffect(() => {
    if (!message) return;
    setIsShowPullMessage(true);
  }, [message]);

  return (
    <>
      {!!token && !!dg_id && (
        <FetchData
          url={API.request_pull_message}
          method="POST"
          body={JSON.stringify({
            service_uuid,
            token,
            action_type
          })}
          onSuccessful={resp => {
            const data = JSON.parse(resp as string);
            const newData = data as PullMessageResponse;
            newData.logs.dg_id = dg_id;
            setMessage(newData as PullMessageResponse);
          }}
          unAuthorized={true}
          isTextResponse={true}
          onError={() => {}}
        />
      )}

      {!!message?.logs.event && counter > 0 && (
        <FetchData
          url={API.request_rescue_log}
          method="POST"
          body={JSON.stringify(message?.logs)}
          onSuccessful={resp => {
            onMessage(message);
          }}
          unAuthorized={true}
          pendingHandlerSetter={setIsLoading}
          counter={counter}
          isTextResponse={true}
          onError={() => {}}
          with_dg_id
        />
      )}

      {isShowPullMessage && (
        <AppPullMessagePopup
          message={message}
          setMessage={setMessage}
          onClose={() => setIsShowPullMessage(false)}
          fetchRescueLog={() => setCounter(prev => prev + 1)}
        />
      )}
    </>
  );
}
